import { useState, useEffect, SetStateAction } from 'react';
import { message } from 'antd';
import { queryAccessories, byNotAccessoryCatagoryId } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { useStateWithLocalStorage } from '@/utils/hooks';

export type IProductData = {
    generalKey: string;
    name: string;
    productCatagoryId: string;
    subs: any[];
    children: ISpuData[];
    sourceId: string;
};

export type ISpuData = {
    spuId: string;
    [key: string]: string;
};

// 埋点需要列表名称 { key: name }
const listNameByKey = {} as { [key: string]: string };

export const useAccessoriesData = (categoryList: IProductData[]) => {
    const { gloproductlist: spuList, gtm, useRouter } = useGlobal();
    // console.log({ spuList });
    const { query, locale } = useRouter();
    const { id } = query;
    // 当前选择品类
    const [active, setActive] = useState('1468462465052164098');
    // 当前选择产品
    const [currentSpu, setCurrentSpu] = useState<ISpuData | null>(null);
    // tab数据
    const [tabList, setTabList] = useState<any>([]);
    // 全产品选择框
    const [visible, setVisible] = useState(false);
    // 全产品选择框数据
    const [productData, setProductData] = useStateWithLocalStorage<IProductData[]>(`${locale}_product`, []);
    // 配件列表数据
    const [productContent, setProductContent] = useState<any[]>([]);

    useEffect(() => {
        if (!categoryList.length) return;
        getData(id);
        setActive(id);
        const tabs = ['product_ps', 'product_sp', 'product_smart'];
        const productList = tabs.map((tab) => categoryList.find((category) => tab === category.generalKey));

        // spulist根据productCatagoryId分类
        const spuKeyObj = {} as { [key: string]: ISpuData[] };
        spuList &&
            spuList.map((itemN: ISpuData) => {
                const item = JSON.parse(JSON.stringify(itemN)); //不可操作原 gloproductlist
                if (spuKeyObj[item.productCatagoryId]) {
                    spuKeyObj[item.productCatagoryId].push(item);
                } else {
                    spuKeyObj[item.productCatagoryId] = [item];
                }
            });
        // console.log({ spuKeyObj });

        // 构建三大类的tab数据
        const tabList = productList.map((item) => {
            // 组装大类目下的子产品

            // sourceId 即 productCatagoryId
            listNameByKey[item.sourceId] = item.name;
            item.children = spuKeyObj[item.sourceId] || [];

            // 若存在子类目则将子类目产品放入一级
            spuList
                .filter((spu: any) => {
                    const subCategories = categoryList.filter((el: any) => el.pid === item.sourceId).map((e: any) => e.sourceId);
                    if (subCategories.length > 0) {
                        return subCategories.includes(spu.productCatagoryId);
                    }
                })
                .map((spuItem: any) => {
                    item.children = item.children.concat(JSON.parse(JSON.stringify(spuItem)));
                });

            // 修改子产品pid指向，服务tabs
            item.children.map((childItem) => (childItem.productCatagoryId = item.sourceId));
            return {
                key: item.sourceId,
                text: item.name,
                value: item.name,
            };
        });
        // console.log({ productList });
        setTabList(tabList);
        setProductData(productList);
    }, [categoryList, spuList]);

    const getData = async (id: string, isSearch = false) => {
        try {
            const res = isSearch ? await queryAccessories({ spuId: id }) : await byNotAccessoryCatagoryId({ productCatagoryId: id });
            if (res.code !== '0') return message.error(res.message);

            const list: SetStateAction<any[]> = [];
            Object.keys(res.data).map((key) => {
                res.data[key].map((item: any) =>
                    list.push({
                        ...item,
                        listName: listNameByKey[id] || '', // 子组件埋点需要列表名称
                    }),
                );
            });
            setProductContent(list);
        } catch (e) {
            console.log('getData===>', e);
        }
    };
    // 搜索配件列表
    const handleSearch = () => {
        setVisible(false);
        if (!currentSpu) return;
        const { name, spuId, productCatagoryId } = currentSpu;

        getData(spuId, true);
        setActive(productCatagoryId);
        const productCatagoryName = productData?.find((catagory: any) => catagory?.sourceId === productCatagoryId)?.name;
        gtm.push({
            event: 'uaEvent',
            event_name: 'accessorie_browseall',
            list_name: productCatagoryName,
            product_name: name,
            button_name: 'ok',
        });
    };
    // 选择产品
    const handleChoose = (item: ISpuData) => {
        if (currentSpu?.spuId !== item.spuId) return setCurrentSpu(item);
        setCurrentSpu(null);
    };
    // 选择品类
    const handleChangeTab = (id: string) => {
        setActive(id);
        getData(id);
        gtm.push({
            event: 'uaEvent',
            event_name: 'accessories_navigation',
            navigation_name: listNameByKey[id] || '',
        });
    };

    return {
        AccessoriesData: {
            tabList,
            productData,
            productContent,
            active,
            visible,
            currentSpu,
        },
        AccessoriesHandle: {
            setVisible,
            handleChoose,
            handleSearch,
            handleChangeTab,
        },
    };
};
